
<template>
  <div class="main-content">
    <Container
      :title="t('route.templateUser')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          ref="searchFormRef"
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <!--<el-button
          v-if="this.$hasPermission(['ACTION_vcTemplateUserEdit'])"
          @click="handleCreate()"
          type="success"
        >
          {{ t('table.add') }}
        </el-button>-->
        <el-button
          v-if="selection.length > 0 && this.$hasPermission(['ACTION_vcTemplateUserEdit'])"
          @click="handleBathDelete()"
          type="danger"
        >
          {{ t('table.bathDelete') }}
        </el-button>
        <SimpleTable
          :isLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :sort="sort"
          :order="order"
          @handleOrder="handleOrder"
          @handleSelection="handleSelection"
        >
          <template
            v-if="this.$hasPermission(['ACTION_vcTemplateUserEdit'])"
            #default="slotProps"
          >
            <el-button
              @click="handleEdit(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>
            <el-button
              @click="handleDelete(slotProps.row.id)"
              type="danger"
              size="mini"
            >
              {{ t('common.delete') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[5, 10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
    <el-dialog
      v-if="this.$hasPermission(['ACTION_vcTemplateUserEdit'])"
      :title="t(textMap[dialogStatus])"
      center
      v-model="dialogFormVisible"
      width="45%"
    >
      <NomalContainer>
        <CenterForm
          v-if="dialogStatus === 'create'"
          :formModel="createModel"
          :formStruct="createStruct"
          :formRules="templateUserRole"
          @submit="createSubmit"
          @reset="createReset"
        />
        <CenterForm
          v-if="dialogStatus === 'update'"
          :formModel="updateModel"
          :formStruct="updateStruct"
          :formRules="templateUserRole"
          @submit="updateNameSubmit"
          @reset="updateNameReset"
        />
      </NomalContainer>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  TemplateUserModel,
  TemplateUserPageSearchModel,
  TemplateUserSearchModel,
  TemplateUserAddModel,
  TemplateUserUpdateModel,
  TemplateUserViewModel,
  IdsModel
} from '@/model/product/TemplateUserModel'
import {
  pageSearchTemplateUser,
  addTemplateUser,
  updateTemplateUser,
  removeTemplateUser,
  batchRemoveTemplateUser
} from '@/apis/product/templateUser'
import { TemplateCategoryUserSearchModel } from '@/model/product/TemplateCategoryUserModel'
import { searchTemplateCategoryUser } from '@/apis/product/templateCategoryUser'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { selectOptionFormat } from '@/utils/options'
import { MaterialType } from '@/constant/options'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const materialTypeOption = selectOptionFormat(MaterialType.materialTypeOptions, t, MaterialType.i18nKey)
    let categorys: any[] = []
    const searchStruct = [
      { prop: 'templateName', label: t('templateUser.templateName'), placeholder: t('templateUser.templateNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'userId', label: t('templateUser.userId'), placeholder: t('templateUser.userIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelWidth', label: t('templateUser.labelWidth'), placeholder: t('templateUser.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('templateUser.labelLength'), placeholder: t('templateUser.labelLengthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'materialType', label: t('templateUser.materialType'), placeholder: t('templateUser.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption }
    ]

    const createStruct = [
      { prop: 'templateName', label: t('templateUser.templateName'), placeholder: t('templateUser.templateNameP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'userCategoryId',
        label: t('templateUser.userCategoryId'),
        placeholder: t('templateUser.userCategoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      { prop: 'labelThumbnail', label: t('templateUser.labelThumbnail'), placeholder: t('templateUser.labelThumbnailP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelContent', label: t('templateUser.labelContent'), placeholder: t('templateUser.labelContentP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelWidth', label: t('templateUser.labelWidth'), placeholder: t('templateUser.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('templateUser.labelLength'), placeholder: t('templateUser.labelLengthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'materialType', label: t('templateUser.materialType'), placeholder: t('templateUser.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption },
      { prop: 'clientId', label: t('templateUser.clientId'), placeholder: t('templateUser.clientIdP'), component: 'el-input', type: 'text', model: null },
      { prop: 'userId', label: t('templateUser.userId'), placeholder: t('templateUser.userIdP'), component: 'el-input', type: 'number', model: null }
    ]

    const updateStruct = [
      { prop: 'templateName', label: t('templateUser.templateName'), placeholder: t('templateUser.templateNameP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'userCategoryId',
        label: t('templateUser.userCategoryId'),
        placeholder: t('templateUser.userCategoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      { prop: 'labelThumbnail', label: t('templateUser.labelThumbnail'), placeholder: t('templateUser.labelThumbnailP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelContent', label: t('templateUser.labelContent'), placeholder: t('templateUser.labelContentP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelWidth', label: t('templateUser.labelWidth'), placeholder: t('templateUser.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('templateUser.labelLength'), placeholder: t('templateUser.labelLengthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'materialType', label: t('templateUser.materialType'), placeholder: t('templateUser.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption },
      { prop: 'clientId', label: t('templateUser.clientId'), placeholder: t('templateUser.clientIdP'), component: 'el-input', type: 'text', model: null },
      { prop: 'userId', label: t('templateUser.userId'), placeholder: t('templateUser.userIdP'), component: 'el-input', type: 'number', model: null }
    ]

    const templateUserRole = {
      templateName: [{ required: true, message: t('templateUser.templateName').concat(t('common.isRequired')), trigger: 'blur' }],
      userCategoryId: [{ required: true, message: t('templateUser.userCategoryId').concat(t('common.isRequired')), trigger: 'blur' }],
      labelThumbnail: [{ required: true, message: t('templateUser.labelThumbnail').concat(t('common.isRequired')), trigger: 'blur' }],
      labelContent: [{ required: true, message: t('templateUser.labelContent').concat(t('common.isRequired')), trigger: 'blur' }],
      labelWidth: [{ required: true, message: t('templateUser.labelWidth').concat(t('common.isRequired')), trigger: 'blur' }],
      labelLength: [{ required: true, message: t('templateUser.labelLength').concat(t('common.isRequired')), trigger: 'blur' }],
      materialType: [{ required: true, message: t('templateUser.materialType').concat(t('common.isRequired')), trigger: 'blur' }],
      clientId: [{ required: true, message: t('templateUser.clientId').concat(t('common.isRequired')), trigger: 'blur' }],
      userId: [{ required: true, message: t('templateUser.userId').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [
      { prop: 'templateName', label: t('templateUser.templateName'), sortable: 'custom' },
      { prop: 'userId', label: t('templateUser.userId'), sortable: 'custom' },
      { prop: 'categoryName', label: t('templateUser.userCategoryId'), formatter: (row: TemplateUserViewModel) => { return categorys.find(c => c.value === row.userCategoryId)?.label }, sortable: 'custom' },
      { prop: 'labelThumbnail', label: t('templateUser.labelThumbnail'), sortable: 'custom', base64: 'labelThumbnail' },
      { prop: 'labelWidth', label: t('templateUser.labelWidth'), sortable: 'custom' },
      { prop: 'labelLength', label: t('templateUser.labelLength'), sortable: 'custom' },
      { prop: 'materialType', label: t('templateUser.materialType'), formatter: (row: TemplateUserViewModel) => { return materialTypeOption.find(mt => mt.value === row.materialType)?.label }, sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: TemplateUserViewModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: TemplateUserViewModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as TemplateUserSearchModel,
      tableData: Array<TemplateUserViewModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'templateUser.edit',
        create: 'templateUser.create'
      },
      dialogFormVisible: false,
      templateUserRole: templateUserRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as TemplateUserAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as TemplateUserUpdateModel,
      editRow: {} as TemplateUserModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: TemplateUserPageSearchModel = {
          templateName: dataMap.searchFormModel.templateName,
          userId: dataMap.searchFormModel.userId,
          labelWidth: dataMap.searchFormModel.labelWidth,
          labelLength: dataMap.searchFormModel.labelLength,
          materialType: dataMap.searchFormModel.materialType,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchTemplateUser(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: TemplateUserAddModel = {
          templateName: dataMap.createModel.templateName,
          userCategoryId: dataMap.createModel.userCategoryId,
          labelThumbnail: dataMap.createModel.labelThumbnail,
          labelContent: dataMap.createModel.labelContent,
          labelWidth: dataMap.createModel.labelWidth,
          labelLength: dataMap.createModel.labelLength,
          materialType: dataMap.createModel.materialType,
          clientId: dataMap.createModel.clientId,
          userId: dataMap.createModel.userId
        }
        const result = await addTemplateUser(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: TemplateUserUpdateModel = {
          id: dataMap.updateModel.id,
          templateName: dataMap.updateModel.templateName,
          userCategoryId: dataMap.updateModel.userCategoryId,
          labelThumbnail: dataMap.updateModel.labelThumbnail,
          labelContent: dataMap.updateModel.labelContent,
          labelWidth: dataMap.updateModel.labelWidth,
          labelLength: dataMap.updateModel.labelLength,
          materialType: dataMap.updateModel.materialType,
          clientId: dataMap.updateModel.clientId,
          userId: dataMap.updateModel.userId
        }
        const result = await updateTemplateUser(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeTemplateUser(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveTemplateUser(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.templateName = dataMap.editRow.templateName
        dataMap.updateModel.userCategoryId = dataMap.editRow.userCategoryId
        dataMap.updateModel.labelThumbnail = dataMap.editRow.labelThumbnail
        dataMap.updateModel.labelContent = dataMap.editRow.labelContent
        dataMap.updateModel.labelWidth = dataMap.editRow.labelWidth
        dataMap.updateModel.labelLength = dataMap.editRow.labelLength
        dataMap.updateModel.materialType = dataMap.editRow.materialType
        dataMap.updateModel.clientId = dataMap.editRow.clientId
        dataMap.updateModel.userId = dataMap.editRow.userId
      },
      createReset() {
        console.log('create reset')
      }
    })
    const getTemplateCategoryUserOptions = async(query: string, userId: number | null = null) => {
      if (dataMap.dialogStatus === 'create') {
        dataMap.createStruct[1].loading = true
      } else if (dataMap.dialogStatus === 'update') {
        dataMap.updateModel.userCategoryId = null
        dataMap.updateStruct[1].loading = true
      }
      const params: TemplateCategoryUserSearchModel = {
        categoryName: query,
        userId: userId,
        clientId: null,
        displayOrder: null
      }
      const data = await searchTemplateCategoryUser(params)
      const list = data?.data ?? []
      const optionList = []
      for (const iterator of list) {
        optionList.push({ label: iterator.categoryName, value: iterator.id })
      }
      if (userId == null) {
        categorys = optionList
      }
      if (dataMap.dialogStatus === 'create') {
        dataMap.createStruct[1].options = optionList
      } else if (dataMap.dialogStatus === 'update') {
        dataMap.updateStruct[1].options = optionList
        dataMap.updateNameReset()
      }
      dataMap.createStruct[1].loading = false
      dataMap.updateStruct[1].loading = false
    }
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      getTemplateCategoryUserOptions('')
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: TemplateUserModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.templateName = row.templateName
        dataMap.updateModel.userCategoryId = row.userCategoryId
        dataMap.updateModel.labelThumbnail = row.labelThumbnail
        dataMap.updateModel.labelContent = row.labelContent
        dataMap.updateModel.labelWidth = row.labelWidth
        dataMap.updateModel.labelLength = row.labelLength
        dataMap.updateModel.materialType = row.materialType
        dataMap.updateModel.clientId = row.clientId
        dataMap.updateModel.userId = row.userId
        getTemplateCategoryUserOptions('', row.userId)
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.createStruct[1].remoteMethod = getTemplateCategoryUserOptions
      dataMap.updateStruct[1].remoteMethod = getTemplateCategoryUserOptions
      getTemplateCategoryUserOptions('')
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
</script>
